module.exports = __webpack_public_path__ + "static/houssein-3ba6db9230399be0cf506106d8d4c854.jpg";